import { Injectable, inject } from '@angular/core';
import { AuthService } from '@app/auth';
import { ApiService } from '@app/gateway';
import { AccountFactory, AccountModel } from '../models';
import { AccountRepository } from '../repository';
import { BaseService } from './base';

@Injectable({ providedIn: 'root' })
export class AccountsService extends BaseService<AccountModel> {
  private readonly apiService = inject(ApiService);
  private readonly authService = inject(AuthService);

  constructor(protected override readonly repository: AccountRepository) {
    super(repository);
  }

  public async account(accountId: string): Promise<AccountModel> {
    try {
      const path: string = `${AccountFactory.getPath()}/admin/account/${accountId}`;
      const account: AccountModel = await this.apiService.get({ path });
      return account;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async accounts(): Promise<AccountModel[]> {
    try {
      const path: string = `${AccountFactory.getPath()}`;
      const accounts: AccountModel[] = await this.apiService.get({ path });
      return accounts;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async updateAccount(accountId: string, update: boolean): Promise<void> {
    const user = await this.authService.profile();
    try {
      const path: string = `updates`;
      const data = {
        accountId: accountId,
        update: update,
        info: update ? 'Aguardando atualização' : 'Atualização cancelada',
        user: user.email,
      };
      await this.apiService.post({ path, data });
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async deactivateAccount(account: AccountModel): Promise<void> {
    try {
      const path: string = `${AccountFactory.getPath()}`;
      const data = {
        ...account,
        demonstracao: true,
      };
      await this.apiService.post({ path, data });
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async backupActive(accountId: string, flag: boolean): Promise<void> {
    try {
      const path: string = `${AccountFactory.getPath()}/backup/active`;
      const data = {
        accountId,
        flag,
      };
      await this.apiService.post({ path, data });
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }
}
